import { Grid, IconButton, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import ClearIcon from "@mui/icons-material/Clear";

import React, { useEffect, useState } from "react";

function RenderDatePicker({ chartFilter, datePicker, setDatePicker }) {
  

  if (chartFilter && chartFilter.name === "mondth") {
    return (
      <Grid item xs={6} md={2} sx={{ display: "flex", alignItems: "center" }}>
        <DatePicker
          views={["year", "month"]}
          label="تاریخ"
          value={datePicker}
          onChange={(newValue) => {
            setDatePicker(newValue);
          }}
          renderInput={(params) => (
            <TextField size="small" {...params} helperText={null} />
          )}
        />
        {/* <IconButton onClick={() => clearDatePicker(setFieldValue, "date1")}>
           <ClearIcon fontSize={"small"} color="error" />
         </IconButton> */}
      </Grid>
    );
  } else if (chartFilter && chartFilter.name === "year") {
    return (
      <Grid item xs={6} md={2} sx={{ display: "flex", alignItems: "center" }}>
        <DatePicker
          views={["year"]}
          label="تاریخ"
          value={datePicker}
          onChange={(newValue) => {
            setDatePicker(newValue);
          }}
          renderInput={(params) => (
            <TextField size="small" {...params} helperText={null} />
          )}
        />
      </Grid>
    );
  } else if (chartFilter && chartFilter.name === "day") {
    return (
      <Grid item xs={6} md={2} sx={{ display: "flex", alignItems: "center" }}>
        <DatePicker
          views={["year", "month", "day"]}
          label="تاریخ"
          value={datePicker}
          onChange={(newValue) => {
            setDatePicker(newValue);
          }}
          renderInput={(params) => (
            <TextField size="small" {...params} helperText={null} />
          )}
        />
      </Grid>
    );
  }
}

export default RenderDatePicker;
